// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AspectRatio_wrapper__fUXUh","imageHover":"AspectRatio_imageHover__vC0Xa"};